import React, { useEffect, useState } from "react";

// components
import MaterialTable from 'material-table';
import { table_translate } from "constants/MaterialTable.js";
import { Spinner} from "reactstrap";
import { formateDate } from "utils/formats";

// utils
import { showMessage } from "utils/message.js";

// api
import relatorio_api from "api/relatorio_api";

export default function PendenciasLoja({ grupoEconomico, startDate, endDate }) {

    const [showLoading, setshowLoading] = useState(false);

    const [list_table, set_list_table] = useState([]);

    const handleLoad = () => {
        setshowLoading(true);
        let body={
            startDate: startDate,
            endDate: endDate,
            grupoEconomico: grupoEconomico
          }
        relatorio_api.getApuracaoDreMensalLoja(body).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_list_table(result.data);
            }
        })
    }

    useEffect(() => {
        handleLoad();
    }, [grupoEconomico]);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <MaterialTable style={{ minHeight: "auto" }}
                title=""
                columns={[
                    { title: 'Mes Ano', field: 'mesAno' },
                    { title: 'Cust Code', field: 'custCode' },
                    { title: 'Nick Name', field: 'nickName' },
                    { title: 'Status Dre', field: 'statusDre' },
                    { title: 'Pendencia', field: 'pendencia' },
                    { title: 'Implantação', field: 'dataImplantacao' , render: (rowData) => rowData.dataImplantacao != null ? formateDate(rowData.dataImplantacao) : "" }
                ]}
                data={list_table}
                isLoading={false}
                localization={table_translate}
                options={{
                    filtering: false,
                    search: false,
                    showTitle: false,
                    exportButton: false,
                    toolbar: false,
                    paging: false,
                    headerStyle: {
                        fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                        fontWeight: '700',
                        color: '#fff',
                        backgroundColor: "#0b3d86",
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        zIndex: 0
                    },
                }}
            />

        </>

    );
}